<template>
    <slot
        :days="days"
        :popup="popup"
        :set-ref="setRef"
        :setup-popup-day="setupPopupDay"
    ></slot>
</template>

<script>
import { format } from 'date-fns';
import { ref, defineComponent, onMounted, nextTick } from 'vue';

import { getPerformances } from '../services/inventory';
import { initialiseScroller } from '../modules/scroller';

export default defineComponent({
    name: 'HomeCalendar',

    setup() {
        const popup = ref({
            title: null,
            items: [],
        });
        const days = ref([]);
        const refs = {};

        const setRef = (ref, el) => {
            refs[ref] = el;
        }

        onMounted(() => {
            loadData()
                .finally(async () => {
                    await nextTick();
                    initialiseScroller(refs.scroller, {
                        slidesPerGroup: 15,
                    });
                });
        });

        const loadData = async () => {
            // The season runs 1 July - 30 June. Show from today to the end of the
            // current season, so the range resets each year without a code change.
            // End of day, not midnight: the day loop below zeroes hours, minutes
            // and seconds but not milliseconds, so a midnight boundary would stop
            // the calendar a day short of 30 June.
            const today = new Date();
            const seasonEndYear = today.getMonth() < 6 ? today.getFullYear() : today.getFullYear() + 1;
            const calendarEnd = new Date(seasonEndYear, 5, 30, 23, 59, 59, 999);

            return getPerformances()
                .then(perfs => {
                    let date = new Date();
                    date.setHours(0);
                    date.setMinutes(0);
                    date.setSeconds(0);

                    while (date <= calendarEnd) {
                        let monthTitle = '';
                        if (days.value.length === 0 || date.getDate() === 1) {
                            monthTitle = format(date, 'MMM');
                        }

                        const endOfDay = new Date(date);
                        endOfDay.setDate(date.getDate() + 1);

                        days.value.push({
                            month_title: monthTitle,
                            day: format(date, 'iii'),
                            date: format(date, 'd'),
                            dateObject: date,
                            is_today: days.value.length === 0,
                            performances: perfs.filter(p => p.performancedate > date && p.performancedate < endOfDay),
                        });

                        date = new Date(endOfDay.getTime());
                    }
                });
        };

        const setupPopupDay = (day) => {
            popup.value.title = format(day.dateObject, 'EEE MMMM d');
            popup.value.items = day.performances;
            const dialog = document.querySelector('#calendar-popup');
            dialog.showModal();
            let popupScroller;

            dialog.querySelectorAll('[data-dialog-close]').forEach(el => {
                el.addEventListener('click', () => {
                    dialog.close();
                    popupScroller.destroy();
                }, false);
            });

            setTimeout(() => {
                popupScroller = initialiseScroller(dialog);
            }, 50);
        };

        return {
            days,
            popup,
            setupPopupDay,
            setRef,
        };
    },
});
</script>
